<template>
  <div class="ak-navbar__item" :class="{ 'ak-navbar__item--grow': grow }">
    <slot />
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  /**
   * @type {String}
   * @description This is the name of the component this will also
   * be the tag name of the component to use in templates
   * @example
   * <ak-navbar-item>
   *   <ak-navbar-button>Click Me</ak-navbar-button>
   * </ak-navbar-item>
   */
  name: 'AkNavbarItem',

  /**
   * @type {Object}
   * @description A collection of properties that may be passed into
   * the component these will be bound to the component instance and
   * may be access in the template and component methods.
   */
  props: {
    grow: {
      type: Boolean,
      default: false,
    },
  },
})
</script>

<style lang="scss">
.ak-navbar__item {
  &--grow {
    flex-grow: 1;
  }
}
</style>
